
import React from "react";
import { useNavigate } from "react-router-dom";
import "../../../assests/css/students/PageNotFound.css";

const PageNotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="ng-page-not-found">
      <div className="ng-page-not-found-content">

        <h1 className="ng-404-number">404</h1>

        <h2>Page Not Found</h2>

        <p>
          Sorry, the page you are looking for does not exist or may have been
          moved.
        </p>

        <button
          className="ng-404-home-btn"
          onClick={() => navigate("/")}
        >
          Go to Home
        </button>

        <button
          className="ng-404-back-btn"
          onClick={() => navigate(-1)}
        >
          Go Back
        </button>

      </div>
    </div>
  );
};

export default PageNotFound;

